import secureLocalStorage from "react-secure-storage";
import React, { Component } from "react";
import { Popup } from "@progress/kendo-react-popup";
import { PanelBar, PanelBarItem } from "@progress/kendo-react-layout";
import { DropDownList, MultiSelect } from "@progress/kendo-react-dropdowns";
import { NumericTextBox, TextArea } from "@progress/kendo-react-inputs";
import { Input } from "@progress/kendo-react-inputs";
import Chip from "@material-ui/core/Chip";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { toastr } from "react-redux-toastr";
import Api from "../../../Services/Api";
import { CircularProgress } from "@material-ui/core";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import Images from "../../../Assets/Images";
import moment from "moment";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { formatNumber } from "@telerik/kendo-intl";
import { Window } from "@progress/kendo-react-dialogs";
import { CustomDateInput } from "../../CustomDateInput";

const TOOptionsData = [
  { text: "Threat", value: "Threat" },
  { text: "Opportunity", value: "Opportunity" },
];

const STATUS = [
  { text: "Open", value: true },
  { text: "Closed", value: false },
];
export default class RiskRegisterFormView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expandMode: "multiple",
      customFieldReq: [],
      impactFieldReq: [],
      impactResponse: [],
      riskTitle: "",
      riskDescription: "",
      threatOrOpportunity: null,
      cause: "",
      consequences: "",
      risktype: [],
      existingControl: "",
      progressStatus: "",
      riskOwner: {},
      status: {},
      probability: 0,
      proximityAlertDate: null,
      riskAlertStakeHolders: [],
      riskAlertDescription: "",
      postProbability: 0,
      currentProbability: 0,
      isDonePopulate: false,
      loader: false,
      preRiskScore: 0,
      currentRiskScore: 0,
      postRiskScore: 0,
      preWeightedRiskScore: 0,
      currentWeightedRiskScore: 0,
      postWeightedRiskScore: 0,
      formEditFlag: false,
      formData: {},
      tempRisktitle: false,
      progressStatusFlag: false,
      impactslist: [],
      probabilityRangeMaster: {},
      weightageList: [],
      qualitativeImpactslist: [],
      openImpactRatingFlag: false,
      skip: 0,
      take: Math.round((window.innerHeight - 250) / 35),
      probabilityvalue: "",
    };

    this.init = this.init.bind(this);
    this.getDisableFlagForSubmit = this.getDisableFlagForSubmit.bind(this);
  }
  progressHistory = () => {
    this.setState({ ...this.state, progressStatusFlag: true });
  };

  closeProgressHistoryPopup = () => {
    this.setState({ ...this.state, progressStatusFlag: false });
  };

  getImpactRatingTable = async () => {
    try {
      this.setState({ loader: true });
      var req = {
        WorkstreamId: this.props.orgUnit.unitId,
      };
      let response = await Api.getImpactRatingTable(req);
      if (response.status === 200 && response.impactRatingTable) {
        let wlist = response.impactRatios ? response.impactRatios : [];

        this.dynamicColsQuantitative(
          response.impactRatingTable,
          response.probabilityRangeResponse
        );
        this.dynamicColsQualititative(
          response.qualityimpactRatingTable,
          response.probabilityRangeResponse
        );

        let arr = response.probabilityRangeResponse;
        let array = response.probabilityRangeResponse;
        let rangeArray = [];
        let probabilityObj = {};
        let probabilityval = {};

        arr = arr?.map((item) => {
          item[item.fullDescription] = item.probabilityRangeValue;
          probabilityObj = { ...probabilityObj, ...item };
          return item;
        });
        array = array?.map((item) => {
          item[item.probabilityDescription] = item.probabilityRangeValue;
          probabilityval = { ...probabilityval, ...item };
          return item;
        });
        rangeArray = arr.map((column, index) => (
          <GridColumn
            key={index}
            field={column.fullDescription}
            title={column.fullDescription + " From"}
            editor="numeric"
            width="110px"
            format="{0:##,#}"
            editable={false}
          />
        ));
        let probabilityArray = array.map((column, index) => (
          <GridColumn
            key={index}
            field={column.probabilityDescription}
            title={column.probabilityDescription + " From"}
            editor="numeric"
            width="110px"
            format="{0:##,#}"
            editable={false}
          />
        ));

        this.setState({
          ...this.state,
          loader: false,
          openImpactRatingFlag: true,
          impactslist: response.impactRatingTable,
          probabilityRangeMaster: [probabilityval],
          weightageList: wlist,
          qualitativeImpactslist: response.qualityimpactRatingTable,
          probabilityColumns: rangeArray,
          probabilityvalue: probabilityArray,
        });
      } else {
        this.setState({
          ...this.state,
          loader: false,
          impactslist: [],
          probabilityRangeMaster: [],
          weightageList: [],
          qualitativeImpactslist: [],
        });
      }
    } catch (error) {
      console.error(error);
      this.setState({
        ...this.state,
        loader: false,
        impactslist: [],
        probabilityRangeMaster: [],
        weightageList: [],
        qualitativeImpactslist: [],
      });
    }
  };
  dynamicColsQuantitative = (data, probabilityRangeResponse) => {
    try {
      data.map((res) => {
        res.impactThresholdValue.map((item) => {
          let field = this.getFieldName(item.orderId, probabilityRangeResponse);
          res[field] = item.thresholdValue;
        });
      });
    } catch (error) {
      // this.setState({ ...this.state, loader: false });
      console.error(error);
    }
  };
  dynamicColsQualititative = (data, probabilityRangeResponse) => {
    try {
      data.map((res) => {
        res.qualitativeImpactValue.map((item) => {
          let field = this.getFieldName(item.orderId, probabilityRangeResponse);
          res[field] = item.qualitativeValue;
        });
      });
    } catch (error) {
      // this.setState({ ...this.state, loader: false });
      console.error(error);
    }
  };
  getFieldName = (orderId, probabilityRangeResponse) => {
    let obj = probabilityRangeResponse.find((item) => item.orderId === orderId);
    return obj?.fullDescription;
  };
  loadEditmode = async (formData) => {
    await this.populateFormData(formData);
  };
  processInput = (input) => {
    if (typeof input === "string") {
      return input.split(",").map((item) => item.trim()); // Optional: trim spaces around items
    } else if (Array.isArray(input)) {
      return input;
    } else {
      return [];
    }
  };
  populateFormData = async (formData) => {
    try {
      this.setState({
        ...this.state,
        formEditFlag: true,
        formData: formData,
        customFieldReq: await this.constructCFState(formData),
        impactFieldReq: await this.constructImpactState(formData),
        impactResponse: formData.impactResponse,
        riskTitle: formData.riskTitle,
        riskDescription: formData.name,
        threatOrOpportunity: TOOptionsData.find(
          (item) => item.text == formData.isOpportunity
        ),
        cause: formData.cause,
        consequences: formData.impactComments,
        risktype: formData.riskTypeIds
          ? this.props.riskTypeList.filter((item) =>
              formData.riskTypeIds.includes(item.id)
            )
          : [],
        existingControl: formData.existingControl,
        progressStatus: formData.progress,
        riskOwner: formData.owner
          ? this.props.ownerListForRisk.find(
              (item) => item.text === formData.owner
            )
          : null,
        status: STATUS.find(
          (item) =>
            item.value == formData.isClosed || item.text == formData.isClosed
        ),
        probability: formData.frequency,
        postProbability: formData.reductionProbability,
        currentProbability: formData.currentProbability,
        proximityAlertDate: formData.proximityDate
          ? new Date(formData.proximityDate)
          : null,
        riskAlertStakeHolders: this.processInput(
          formData.riskAlertStakeHolders
        ),
        riskAlertDescription: formData.alertDescription,
        preRiskScore: formData.preRiskScore,
        currentRiskScore: formData.currentRiskScore,
        postRiskScore: formData.postRiskScore,
        preWeightedRiskScore: formData.preWeightedRiskScore,
        currentWeightedRiskScore: formData.currentWeightedRiskScore,
        postWeightedRiskScore: formData.postWeightedRiskScore,
        isDonePopulate: true,
        loader: false,
      });
    } catch (err) {
      console.error(err);
    }
  };
  constructCFState = (formData) => {
    let arr = [];
    try {
      formData.customFields.map((cf) => {
        let temp =
          this.props.orgUnit.customFields &&
          this.props.orgUnit.customFields.find(
            (item) => item.customFieldId === cf.id
          );
        // console.log("aaaa",aaaa);
        if (cf.inputType == "Multi Drop Down") {
          arr.push({
            CustomFieldId: cf.id,
            inputType: cf.inputType,
            value: temp.cfPossibleValues.filter((item) =>
              cf.selectedCustomFieldIds.includes(item.id)
            ),
          });
        } else if (cf.inputType == "Single Drop Down") {
          arr.push({
            CustomFieldId: cf.id,
            inputType: cf.inputType,
            value: cf.cfPossibleValues.find((item) =>
              cf.selectedCustomFieldIds.includes(item.id)
            ),
          });
        } else if (cf.inputType == "Free Text") {
          arr.push({
            CustomFieldId: cf.id,
            inputType: cf.inputType,
            value: cf.multiText,
          });
        } else if (cf.inputType == "Numeric") {
          arr.push({
            CustomFieldId: cf.id,
            inputType: cf.inputType,
            value: cf.multiText,
          });
        } else if (cf.inputType == "Date") {
          arr.push({
            CustomFieldId: cf.id,
            inputType: cf.inputType,
            value: cf.multiText ? new Date(cf.multiText) : null,
          });
        }
      });
      // this.setState({ ...this.state, customFieldReq: arr });
      return arr;
    } catch (err) {
      console.error(err);
      return [];
    }
  };
  constructImpactState = (formData) => {
    try {
      let arr = [];
      formData.impactResponse &&
        formData.impactResponse.map((impact) => {
          if (impact.type === "Pre" && impact.impactType === "Quantitative") {
            arr.push({
              impactId: impact.impactId,
              impactType: impact.impactType,
              value: impact.value,
            });
          } else if (
            impact.type === "Pre" &&
            impact.impactType === "Qualitative"
          ) {
            arr.push({
              impactId: impact.impactId,
              impactType: impact.impactType,
              value: impact.qValue,
            });
          }
        });
      return arr;
    } catch (err) {
      console.error(err);
      return [];
    }
  };
  handleCustomFieldValue = (e, CfItem) => {
    try {
      let cfObj = {
        CustomFieldId: CfItem.customFieldId,
        inputType: CfItem.inputType,
        value: CfItem.inputType === "Date" ? e.target.value : e.value,
      };
      let arr = this.state.customFieldReq;
      if (arr.some((item) => item.CustomFieldId === CfItem.customFieldId)) {
        let index = arr.findIndex(
          (item) => item.CustomFieldId == CfItem.customFieldId
        );
        arr[index] = cfObj;
      } else {
        arr.push(cfObj);
      }
      this.setState({ ...this.state, customFieldReq: arr });
    } catch (err) {
      console.error(err);
    }
  };
  handleImpactFieldValue = (e, impact) => {
    try {
      let impactObj = {
        impactId: impact.impactId,
        impactType: impact.impactType,
        value: e.value,
      };
      let arr = this.state.impactFieldReq;
      if (arr.some((item) => item.impactId === impact.impactId)) {
        let index = arr.findIndex((item) => item.impactId == impact.impactId);
        // console.log("index", index);
        arr[index] = impactObj;
      } else {
        arr.push(impactObj);
      }
      // console.log("arr", arr);
      this.setState({ ...this.state, impactFieldReq: arr });
    } catch (err) {
      console.error(err);
    }
  };
  refreshRisk = async () => {
    try {
      let request = {
        riskRegisterId:
          this.state.formEditFlag === true
            ? this.state.formData.riskRegisterId
            : 0,
        number:
          this.state.formEditFlag === true ? this.state.formData.number : null,
        organizationUnitId: this.props.orgUnit.unitId,
        RiskImpacts: this.state.impactFieldReq,
        riskTitle: this.state.riskTitle,
        riskDescription: this.state.riskDescription,
        threatOrOpportunity: this.state.threatOrOpportunity.text,
        cause: this.state.cause,
        consequences: this.state.consequences,
        existingControl: this.state.existingControl,
        progressStatus: this.state.progressStatus,
        riskOwner: this.state.riskOwner,
        status: this.state.status ? this.state.status.text : null,
        probability: this.state.probability,
        proximityAlertDate: this.state.proximityAlertDate,
        riskAlertStakeHolders: this.processInput(
          this.state.riskAlertStakeHolders
        ),
        riskAlertDescription: this.state.riskAlertDescription,
      };
      let response = await Api.RiskRegisterCalculation(request);
      if (response.status === 200) {
        this.populateRefreshCalculation(response.riskReg);
      }
    } catch (err) {
      console.error(err);
      this.setState({ ...this.state, loader: false });
    }
  };

  populateRefreshCalculation = async (formData) => {
    try {
      this.setState({
        ...this.state,
        impactFieldReq: await this.constructImpactState(formData),
        impactResponse: formData.impactResponse,
        //probability: formData.frequency,
        postProbability: formData.reductionProbability,
        currentProbability: formData.currentProbability,
        preRiskScore: formData.preRiskScore,
        currentRiskScore: formData.currentRiskScore,
        postRiskScore: formData.postRiskScore,
        preWeightedRiskScore: formData.preWeightedRiskScore,
        currentWeightedRiskScore: formData.currentWeightedRiskScore,
        postWeightedRiskScore: formData.postWeightedRiskScore,
        isDonePopulate: true,
        loader: false,
      });
    } catch (err) {
      console.error(err);
      this.setState({ ...this.state, loader: false });
    }
  };
  saveRisk = async () => {
    //AddRiskRegister
    this.setState({ ...this.state, loader: true, isDonePopulate: true });
    try {
      let request = {
        riskRegisterId:
          this.state.formEditFlag === true
            ? this.state.formData.riskRegisterId
            : 0,
        number:
          this.state.formEditFlag === true ? this.state.formData.number : null,
        organizationUnitId: this.props.orgUnit.unitId,
        RiskImpacts: this.state.impactFieldReq,
        RiskCustomFields: this.state.customFieldReq
          ? await this.changeCFKeyName(this.state.customFieldReq)
          : [],
        riskTitle: this.state.riskTitle?.slice(0, 30),
        riskDescription: this.state.riskDescription,
        threatOrOpportunity: this.state.threatOrOpportunity.text,
        cause: this.state.cause,
        consequences: this.state.consequences,
        riskTypeIds: this.state.risktype
          ? this.state.risktype.map((item) => {
              return item.id;
            })
          : [],
        existingControl: this.state.existingControl,
        progressStatus: this.state.progressStatus,
        riskOwner: this.state.riskOwner,
        status: this.state.status ? this.state.status.text : null,
        probability:
          this.state.probability > 100 ? 100 : this.state.probability,
        proximityAlertDate: this.state.proximityAlertDate,
        riskAlertStakeHolders: this.processInput(
          this.state.riskAlertStakeHolders
        ),
        riskAlertDescription: this.state.riskAlertDescription,
      };
      let response = await Api.AddRiskRegisterForm(request);
      if (response.status === 200) {
        toastr.success(response.message);
        if (response.riskReg) {
          await this.init("RESET");
          await this.loadEditmode(response.riskReg);
          if (request.number) {
            this.props.addRiskDataFromForm("UPDATE", response.riskReg);
            this.init("CANCEL");
          } else {
            this.props.addRiskDataFromForm("ADD", response.riskReg);
            this.init("CANCEL");
          }
        }
        this.setState({ ...this.state, loader: false });
      } else {
        toastr.error(response.message);
        this.setState({ ...this.state, loader: false });
      }
    } catch (err) {
      console.error(err);
      this.setState({ ...this.state, loader: false });
    }
  };
  changeCFKeyName = (cfArray) => {
    let arr = [];
    try {
      cfArray.forEach((element) => {
        if (element.inputType == "Multi Drop Down") {
          arr.push({
            CustomFieldId: element.CustomFieldId,
            inputType: element.inputType,
            MultiDropDownValue: element.value,
          });
        } else if (element.inputType == "Single Drop Down") {
          arr.push({
            CustomFieldId: element.CustomFieldId,
            inputType: element.inputType,
            SingleDropDownValue: element.value,
          });
        } else if (element.inputType == "Free Text") {
          arr.push({
            CustomFieldId: element.CustomFieldId,
            inputType: element.inputType,
            FreeTextValue: element.value,
          });
        } else if (element.inputType == "Numeric") {
          arr.push({
            CustomFieldId: element.CustomFieldId,
            inputType: element.inputType,
            NumericValue: element.value,
          });
        } else if (element.inputType == "Date") {
          arr.push({
            CustomFieldId: element.CustomFieldId,
            inputType: element.inputType,
            DateValue: element.value,
          });
        }
      });
    } catch (err) {
      console.error(err);
    }
    return arr;
  };
  getCFValue = (cf) => {
    try {
      let obj =
        this.state.customFieldReq &&
        this.state.customFieldReq.find(
          (item) => item.CustomFieldId === cf.customFieldId
        );

      if (obj) {
        // let cfObj = this.props.orgUnit.customFields.find(
        //   (item) => item.customFieldId === obj.CustomFieldId
        // );
        // if (cfObj) {
        return obj.value;
        // }
      } else {
        return "";
      }
    } catch (err) {
      console.error(err);
    }
    return;
  };
  getImpactValue = (impact) => {
    try {
      let impactObj = this.state.impactFieldReq.find(
        (item) => item.impactId === impact.impactId
      );
      if (impactObj && impact.impactType === "Quantitative") {
        return impactObj.value;
      } else if (impactObj && impact.impactType === "Qualitative") {
        return impactObj.qValue ? impactObj.qValue : impactObj.value;
      }
    } catch (err) {
      console.error(err);
    }
    return 0;
  };

  itemRender = (li, itemProps) => {
    const itemChildren = (
      <span>
        <input
          type="checkbox"
          checked={itemProps.selected}
          onChange={() => {}}
        />
        &nbsp;{li.props.children}
      </span>
    );
    return React.cloneElement(li, li.props, itemChildren);
  };

  init = async (flag) => {
    if (flag == "CANCEL") {
      this.setState({
        customFieldReq: [],
        impactFieldReq: [],
        impactResponse: [],
        riskTitle: "",
        riskDescription: "",
        threatOrOpportunity: null,
        cause: "",
        consequences: "",
        risktype: [],
        existingControl: "",
        progressStatus: "",
        riskOwner: {},
        status: {},
        probability: 0,
        proximityAlertDate: null,
        riskAlertStakeHolders: [],
        riskAlertDescription: "",
        postProbability: 0,
        currentProbability: 0,
        isDonePopulate: false,
        preRiskScore: 0,
        currentRiskScore: 0,
        postRiskScore: 0,
        preWeightedRiskScore: 0,
        currentWeightedRiskScore: 0,
        postWeightedRiskScore: 0,
        formEditFlag: false,
        loader: false,
      });
      this.props.closeRiskFormView();
    } else {
      this.setState({
        customFieldReq: [],
        impactFieldReq: [],
        impactResponse: [],
        riskTitle: "",
        riskDescription: "",
        threatOrOpportunity: null,
        cause: "",
        consequences: "",
        risktype: [],
        existingControl: "",
        progressStatus: "",
        riskOwner: {},
        status: {},
        probability: 0,
        proximityAlertDate: null,
        riskAlertStakeHolders: [],
        riskAlertDescription: "",
        postProbability: 0,
        currentProbability: 0,
        formEditFlag: false,
        preRiskScore: 0,
        currentRiskScore: 0,
        postRiskScore: 0,
        preWeightedRiskScore: 0,
        currentWeightedRiskScore: 0,
        postWeightedRiskScore: 0,
        loader: false,
      });
    }
  };

  getImpactCurrentAndPostValue = (impact, type) => {
    try {
      if (this.state.formEditFlag === true) {
        let impactObj =
          this.state.impactResponse &&
          this.state.impactResponse.find(
            (item) => item.impactId === impact.impactId && item.type === type
          );
        if (
          impactObj &&
          impactObj.type === "Current" &&
          impact.impactType === "Quantitative"
        ) {
          return impactObj.currentImpactValue;
        } else if (
          impactObj &&
          impactObj.type === "Post" &&
          impact.impactType === "Quantitative"
        ) {
          return impactObj.postImpactValue;
        } else if (
          impactObj &&
          impactObj.type === "Current" &&
          impact.impactType === "Qualitative"
        ) {
          return impactObj.currentQvalue;
        } else if (
          impactObj &&
          impactObj.type === "Post" &&
          impact.impactType === "Qualitative"
        ) {
          return impactObj.postQvalue;
        }
      }
    } catch (err) {
      console.error(err);
    }
  };

  riskalertstakeholderValue = (e, values) => {
    var val = [];
    val = values[values.length - 1];
    let mailvalidity = /^([a-zA-Z0-9\._]+)@([a-zA-Z0-9])+.([a-z]+)(.[a-z]+)?$/;

    if (
      val &&
      (val.trim().length == 0 ||
        (!(val.includes("(") && val.includes(")")) &&
          mailvalidity.test(val) == false))
    ) {
      toastr.error("Please enter a valid email address");
    } else {
      this.setState({
        ...this.state,
        riskAlertStakeHolders: values,
      });
    }
  };

  risktitleValue = (e) => {
    var val = e.target.value.trim();
    if (val == 0) {
      this.setState({
        ...this.state,
        riskTitle: e.target.value,
        tempRisktitle: true,
      });
    } else {
      this.setState({
        ...this.state,
        riskTitle: e.target.value,
        tempRisktitle: false,
      });
    }
  };

  getDisableFlag = () => {
    let flag = false;
    const loginUserId = parseInt(secureLocalStorage.getItem("loginUserId"));
    const ownerId = this.state.formData.userId;
    const role = this.state.formData.role;
    if (loginUserId === ownerId) {
      flag = false;
    } else if (role === "View Only" || role === "Standard User") {
      flag = true;
    }
    return flag;
  };

  getDisableFlagForSubmit = () => {
    let flag = false;
    const loginUserId = parseInt(secureLocalStorage.getItem("loginUserId"));
    const ownerId = this.state.formData.userId;
    const role = this.state.formData.role;
    if (loginUserId === ownerId) {
      flag = false;
    } else if (role === "View Only" || role === "Standard User") {
      flag = true;
    } else if (
      !this.state.riskTitle ||
      this.state.riskTitle === "" ||
      !this.state.threatOrOpportunity
    ) {
      flag = true;
    }
    return flag;
  };

  impactRatingClose = () => {
    this.setState({ openImpactRatingFlag: false });
  };
  openImpactRatingTable = () => {
    this.getImpactRatingTable();
  };
  pageChange = (event) => {
    this.setState({ skip: event.page.skip, take: event.page.take });
  };
  isHiddenRiskColumn = (field) => {
    return !this.props.selectedRisksColumnFields?.some(
      (item) => item.fieldName === field
    );
  };
  render() {
    const {
      expandMode,
      openImpactRatingFlag,
      probabilityRangeMaster,
      impactslist,
      weightageList,
      qualitativeImpactslist,
      skip,
      take,
    } = this.state;
    let isPrime = this.props.orgUnit.isPrime ? true : false;
    const isDisabled = this.getDisableFlag();

    return (
      <div>
        <Popup
          show={this.props.showFormView}
          popupClass={"popup-content popup-wrapper"}
        >
          <div className="addriskFormview">
            <div className="Formview">
              <h3>
                {this.state.formEditFlag === true
                  ? "Update Risk - " + this.state.formData.number
                  : "Add Risk"}{" "}
              </h3>
              <div className="RatingTablebtn" title="Rating Table">
                <a onClick={() => this.openImpactRatingTable()}>Rating Table</a>
              </div>
            </div>
            {this.state.loader ? (
              <span className="MatTableSpinner">
                <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
              </span>
            ) : null}

            <PanelBar expandMode={expandMode}>
              <PanelBarItem title={"Risk Information"} expanded={true}>
                <div className="riskRow">
                  <div className="riskCol col2">
                    <div className="fieldCont" title={this.state.riskTitle}>
                      <label>Risk Title *</label>

                      <Input
                        onChange={(e) => {
                          this.setState({
                            ...this.state,
                            riskTitle: e.value,
                          });
                        }}
                        value={
                          this.state.riskTitle
                            ? this.state.riskTitle.trimStart()
                            : ""
                        }
                        disabled={isDisabled}
                      />
                    </div>
                  </div>
                  {this.isHiddenRiskColumn("name") && (
                    <div className="riskCol col6">
                      <div
                        className="fieldCont"
                        title={this.state.riskDescription}
                      >
                        <label>Risk Description</label>

                        <TextArea
                          onChange={(e) => {
                            this.setState({
                              ...this.state,
                              riskDescription: e.value,
                            });
                          }}
                          value={this.state.riskDescription}
                          disabled={isDisabled}
                        />
                      </div>
                    </div>
                  )}

                  <div className="riskCol col2">
                    <div className="fieldCont">
                      <label>Threat / Opportunity *</label>
                      <DropDownList
                        style={{ width: "100px" }}
                        onChange={(e) => {
                          this.setState({
                            ...this.state,
                            threatOrOpportunity: e.target.value,
                          });
                        }}
                        //   value={selectedValue ? selectedValue : value}
                        data={TOOptionsData}
                        valueField="value"
                        textField="text"
                        //defaultItem={TOOptionsData[0]}
                        value={this.state.threatOrOpportunity}
                        disabled={isDisabled}
                      />
                    </div>
                  </div>
                </div>
                <div className="riskRow">
                  {this.isHiddenRiskColumn("cause") && (
                    <div className="riskCol col4">
                      <div className="fieldCont" title={this.state.cause}>
                        <label>Cause</label>
                        <TextArea
                          onChange={(e) => {
                            this.setState({
                              ...this.state,
                              cause: e.value,
                            });
                          }}
                          value={this.state.cause}
                          disabled={isDisabled}
                        />
                      </div>
                    </div>
                  )}
                  {this.isHiddenRiskColumn("impactComments") && (
                    <div className="riskCol col4">
                      <div
                        className="fieldCont"
                        title={this.state.consequences}
                      >
                        <label>Consequences</label>

                        <TextArea
                          onChange={(e) => {
                            this.setState({
                              ...this.state,
                              consequences: e.value,
                            });
                          }}
                          value={this.state.consequences}
                          disabled={isDisabled}
                        />
                      </div>
                    </div>
                  )}
                  {this.isHiddenRiskColumn("existingControl") && (
                    <div className="riskCol col4">
                      <div
                        className="fieldCont"
                        title={this.state.existingControl}
                      >
                        <label>Existing Control</label>

                        <TextArea
                          onChange={(e) => {
                            this.setState({
                              ...this.state,
                              existingControl: e.value,
                            });
                          }}
                          value={this.state.existingControl}
                          disabled={isDisabled}
                        />
                      </div>
                    </div>
                  )}
                  {this.isHiddenRiskColumn("progress") && (
                    <div className="riskCol col4">
                      <div
                        className="fieldCont"
                        title={this.state.progressStatus}
                      >
                        <label>Progress Status</label>

                        <TextArea
                          onChange={(e) => {
                            this.setState({
                              ...this.state,
                              progressStatus: e.value,
                            });
                          }}
                          value={this.state.progressStatus}
                          disabled={isDisabled}
                        />
                      </div>
                    </div>
                  )}

                  {this.state.formEditFlag === true && this.isHiddenRiskColumn("progress")&& (
                    <div className="riskCol col2">
                      <div
                        className="fieldCont progressHistory"
                        title="Progress History"
                        style={{ marginTop: "26px" }}
                      >
                        <button
                          className="btnPrimary"
                          onClick={() => this.progressHistory()}
                        >
                          Progress History
                        </button>
                      </div>
                    </div>
                  )}
                  {this.isHiddenRiskColumn("riskTypeNames") && (
                    <div className="riskCol col4">
                      <div className="fieldCont">
                        <label>Risk Type</label>
                        <MultiSelect
                          id="risktypeId"
                          onChange={(e) => {
                            this.setState({
                              ...this.state,
                              risktype: e.target.value,
                            });
                          }}
                          itemRender={this.itemRender}
                          value={this.state.risktype}
                          disabled={isDisabled}
                          data={this.props ? this.props.riskTypeList : []}
                          valueField="value"
                          textField="text"
                          autoClose={false}
                        />
                      </div>
                    </div>
                  )}
                  {this.isHiddenRiskColumn("owner") && (
                    <div className="riskCol col2">
                      <div className="fieldCont">
                        <label>Risk Owner</label>
                        <DropDownList
                          onChange={(e) => {
                            this.setState({
                              ...this.state,
                              riskOwner: e.target.value,
                            });
                          }}
                          value={this.state.riskOwner}
                          disabled={isDisabled}
                          data={this.props ? this.props.ownerListForRisk : []}
                          valueField="value"
                          textField="text"
                        />
                      </div>
                    </div>
                  )}
                  {this.isHiddenRiskColumn("isClosed") && (
                    <div className="riskCol col2">
                      <div className="fieldCont">
                        <label>Status</label>
                        <DropDownList
                          disabled={isDisabled}
                          value={this.state.status}
                          onChange={(e) => {
                            this.setState({
                              ...this.state,
                              status: e.target.value,
                            });
                          }}
                          data={STATUS}
                          valueField="value"
                          textField="text"
                        />
                      </div>
                    </div>
                  )}
                </div>
              </PanelBarItem>
              <PanelBarItem title={"Custom Fields"}>
                <div className="riskRow">
                  {this.props.orgUnit &&
                    this.props.orgUnit.customFields &&
                    this.props.orgUnit.customFields.map((CfItem) => {
                      if (
                        CfItem.inputType === "Numeric" &&
                        this.isHiddenRiskColumn(CfItem.fieldName)
                      ) {
                        return (
                          <div
                            className="riskCol col3"
                            key={CfItem.customFieldId}
                          >
                            <div className="fieldCont">
                              <label>{CfItem.fieldName}</label>
                              <NumericTextBox
                                value={this.getCFValue(CfItem)}
                                disabled={isDisabled}
                                onChange={(e) =>
                                  this.handleCustomFieldValue(e, CfItem)
                                }
                              />
                            </div>
                          </div>
                        );
                      } else if (
                        CfItem.inputType === "Free Text" &&
                        this.isHiddenRiskColumn(CfItem.fieldName)
                      ) {
                        return (
                          <div
                            className="riskCol col3"
                            key={CfItem.customFieldId}
                          >
                            <div
                              className="fieldCont"
                              title={this.getCFValue(CfItem)}
                            >
                              <label>{CfItem.fieldName}</label>
                              <TextArea
                                onChange={(e) =>
                                  this.handleCustomFieldValue(e, CfItem)
                                }
                                value={this.getCFValue(CfItem)}
                                disabled={isDisabled}
                              />
                            </div>
                          </div>
                        );
                      } else if (
                        CfItem.inputType === "Date" &&
                        this.isHiddenRiskColumn(CfItem.fieldName)
                      ) {
                        return (
                          <div
                            className="riskCol col3"
                            key={CfItem.customFieldId}
                          >
                            <div className="fieldCont">
                              <label>{CfItem.fieldName}</label>

                              <DatePicker
                                format="dd-MMM-yyyy"
                                id="datefield"
                                onChange={(e) =>
                                  this.handleCustomFieldValue(e, CfItem)
                                }
                                value={this.getCFValue(CfItem)}
                                disabled={isDisabled}
                              />
                            </div>
                          </div>
                        );
                      } else if (
                        CfItem.inputType === "Single Drop Down" &&
                        this.isHiddenRiskColumn(CfItem.fieldName)
                      ) {
                        return (
                          <div
                            className="riskCol col3"
                            key={CfItem.customFieldId}
                          >
                            <div className="fieldCont">
                              <label>{CfItem.fieldName}</label>
                              <DropDownList
                                style={{ width: "100px" }}
                                onChange={(e) =>
                                  this.handleCustomFieldValue(e, CfItem)
                                }
                                value={this.getCFValue(CfItem)}
                                disabled={isDisabled}
                                data={
                                  CfItem.cfPossibleValues
                                    ? [
                                        {
                                          hashValue: "",
                                          id: 0,
                                          possibleValues: " [blank]",
                                        },
                                      ].concat(CfItem.cfPossibleValues)
                                    : []
                                }
                                valueField="id"
                                textField="possibleValues"
                              />
                            </div>
                          </div>
                        );
                      } else if (
                        CfItem.inputType === "Multi Drop Down" &&
                        this.isHiddenRiskColumn(CfItem.fieldName)
                      ) {
                        return (
                          <div
                            className="riskCol col3"
                            key={CfItem.customFieldId}
                          >
                            <div className="fieldCont">
                              <label>{CfItem.fieldName}</label>
                              <MultiSelect
                                style={{ width: "100px !important" }}
                                onChange={(e) =>
                                  this.handleCustomFieldValue(e, CfItem)
                                }
                                // onBlur={this.handleChangeBlur}
                                itemRender={this.itemRender}
                                value={this.getCFValue(CfItem)}
                                disabled={isDisabled}
                                id="customeFieldId"
                                data={
                                  CfItem.cfPossibleValues
                                    ? CfItem.cfPossibleValues
                                    : []
                                }
                                valueField="id"
                                textField="possibleValues"
                                autoClose={false}
                              />
                            </div>
                          </div>
                        );
                      }
                    })}
                </div>
              </PanelBarItem>
              <PanelBarItem title={"Probability"}>
                <div className="riskRow">
                  {this.isHiddenRiskColumn("frequency") && (
                    <div className="riskCol col3">
                      <div className="fieldCont">
                        <label>Probability (Pre) %</label>
                        <NumericTextBox
                          value={
                            this.state.probability > 100
                              ? 100
                              : this.state.probability
                          }
                          disabled={isDisabled}
                          onChange={(e) => {
                            this.setState({
                              ...this.state,
                              probability: e.target.value,
                            });
                          }}
                          min={0}
                          max={100}
                        />
                      </div>
                    </div>
                  )}

                  {this.state.formEditFlag === true &&
                    this.isHiddenRiskColumn("currentProbability") && (
                      <div className="riskCol col3">
                        <div className="fieldCont">
                          <label>Probability (Current) %</label>
                          <NumericTextBox
                            value={this.state.currentProbability}
                            className="turquoiseBlue"
                            onChange={(e) => {
                              this.setState({
                                ...this.state,
                                currentProbability: e.target.value,
                              });
                            }}
                            disabled={true}
                          />
                        </div>
                      </div>
                    )}
                  {this.state.formEditFlag === true &&
                    this.isHiddenRiskColumn("reductionProbability") && (
                      <div className="riskCol col3">
                        <div className="fieldCont ">
                          <label>Probability (Post) %</label>
                          <NumericTextBox
                            value={this.state.postProbability}
                            onChange={(e) => {
                              this.setState({
                                ...this.state,
                                postProbability: e.target.value,
                              });
                            }}
                            className="yellowCell"
                            disabled={true}
                          />
                        </div>
                      </div>
                    )}
                </div>
              </PanelBarItem>

              <PanelBarItem title={"Impacts"} className="Impactsfiled">
                <div>
                  {this.props.orgUnit &&
                    this.props.orgUnit.impactThresholds &&
                    this.props.orgUnit.impactThresholds.map((impact) => {
                      return (
                        <div className="riskRow" key={impact.impactId}>
                          <div className="riskCol col3">
                            <div className="fieldCont">
                              {/* <label>{impact.impactName} / {impact.units} (Pre)</label> */}
                              <label>
                                {" "}
                                {impact.impactType === "Quantitative"
                                  ? impact.impactName + " / " + impact.units
                                  : impact.impactName}{" "}
                                (Pre)
                              </label>
                              {impact.impactType === "Quantitative" ? (
                                <NumericTextBox
                                  value={this.getImpactValue(impact)}
                                  onChange={(e) =>
                                    this.handleImpactFieldValue(e, impact)
                                  }
                                  disabled={isDisabled}
                                />
                              ) : (
                                <DropDownList
                                  style={{ width: "100px" }}
                                  onChange={(e) =>
                                    this.handleImpactFieldValue(e, impact)
                                  }
                                  value={this.getImpactValue(impact)}
                                  data={[0, 1, 2, 3, 4, 5, 6, 7, 8].slice(
                                    0,
                                    this.props.heatMapCount + 1
                                  )}
                                  disabled={isDisabled}
                                />
                              )}
                            </div>
                          </div>
                          {this.state.formEditFlag === true && (
                            <div className="riskCol col3">
                              <div className="fieldCont">
                                <label>
                                  {impact.impactName}/ {impact.units} (Current)
                                </label>
                                {impact.impactType === "Quantitative" ? (
                                  <NumericTextBox
                                    className="turquoiseBlue"
                                    value={this.getImpactCurrentAndPostValue(
                                      impact,
                                      "Current"
                                    )}
                                    disabled={true}
                                  />
                                ) : (
                                  <DropDownList
                                    style={{ width: "100px" }}
                                    className="turquoiseBlue"
                                    value={this.getImpactCurrentAndPostValue(
                                      impact,
                                      "Current"
                                    )}
                                    data={[0, 1, 2, 3, 4, 5, 6, 7, 8].slice(
                                      0,
                                      this.props.heatMapCount + 1
                                    )}
                                    disabled={true}
                                  />
                                )}
                              </div>
                            </div>
                          )}
                          {this.state.formEditFlag === true && (
                            <div className="riskCol col3">
                              <div className="fieldCont">
                                <label>
                                  {impact.impactName} / {impact.units} (Post)
                                </label>
                                {impact.impactType === "Quantitative" ? (
                                  <NumericTextBox
                                    value={this.getImpactCurrentAndPostValue(
                                      impact,
                                      "Post"
                                    )}
                                    className="yellowCell"
                                    disabled={true}
                                  />
                                ) : (
                                  <DropDownList
                                    style={{ width: "100px" }}
                                    className="yellowCell"
                                    value={this.getImpactCurrentAndPostValue(
                                      impact,
                                      "Post"
                                    )}
                                    data={[0, 1, 2, 3, 4, 5, 6, 7, 8].slice(
                                      0,
                                      this.props.heatMapCount + 1
                                    )}
                                    disabled={true}
                                  />
                                )}
                              </div>
                            </div>
                          )}
                        </div>
                      );
                    })}
                </div>
              </PanelBarItem>
              <PanelBarItem
                title="Risk Score"
                disabled={!this.state.formEditFlag}
              >
                <div className="riskRow">
                  {this.isHiddenRiskColumn("preRiskScore") && (
                    <div className="riskCol col3">
                      <div className="fieldCont">
                        <label>Risk Score (Pre)</label>
                        <NumericTextBox
                          value={this.state.preRiskScore}
                          disabled={true}
                        />
                      </div>
                    </div>
                  )}
                  {this.isHiddenRiskColumn("currentRiskScore") && (
                    <div className="riskCol col3">
                      <div className="fieldCont">
                        <label>Risk Score (Current)</label>
                        <NumericTextBox
                          value={this.state.currentRiskScore}
                          disabled={true}
                          className="turquoiseBlue"
                        />
                      </div>
                    </div>
                  )}
                  {this.isHiddenRiskColumn("postRiskScore") && (
                    <div className="riskCol col3">
                      <div className="fieldCont">
                        <label>Risk Score (Post)</label>
                        <NumericTextBox
                          value={this.state.postRiskScore}
                          disabled={true}
                          className="yellowCell"
                        />
                      </div>
                    </div>
                  )}
                </div>
                {isPrime && (
                  <div className="riskRow">
                    <div className="riskCol col3">
                      <div className="fieldCont">
                        <label>Prime Risk Score (Pre)</label>
                        <NumericTextBox
                          value={this.state.preWeightedRiskScore}
                          disabled={true}
                        />
                      </div>
                    </div>
                    <div className="riskCol col3">
                      <div className="fieldCont">
                        <label>Prime Risk Score (Current)</label>
                        <NumericTextBox
                          value={this.state.currentWeightedRiskScore}
                          disabled={true}
                          className="turquoiseBlue"
                        />
                      </div>
                    </div>
                    <div className="riskCol col3">
                      <div className="fieldCont">
                        <label>Prime Risk Score (Post)</label>
                        <NumericTextBox
                          value={this.state.postWeightedRiskScore}
                          disabled={true}
                          className="yellowCell"
                        />
                      </div>
                    </div>
                  </div>
                )}
              </PanelBarItem>
              <PanelBarItem title={"Proximity Alert"}>
                <div className="riskRow">
                  {this.isHiddenRiskColumn("proximityDate") && (
                    <div className="riskCol col5">
                      <div className="fieldCont">
                        <label>Proximity Alert Date</label>
                        <DatePicker
                          format="dd-MMM-yyyy"
                          id="datefield"
                          onChange={(e) => {
                            this.setState({
                              ...this.state,
                              proximityAlertDate: e.target.value,
                            });
                          }}
                          value={this.state.proximityAlertDate}
                          disabled={isDisabled}
                          dateInput={CustomDateInput}
                        />
                      </div>
                      <div className="fieldCont" style={{ marginTop: "15px" }}>
                        <label>Alert Stakeholders</label>
                        <Autocomplete
                          multiple
                          id="emailbcc"
                          // autoSelect={true}
                          options={this.props.dropDownData.map(
                            (option) => option.displayName
                          )}
                          freeSolo
                          disableCloseOnSelect
                          onChange={this.riskalertstakeholderValue}
                          disabled={isDisabled}
                          value={this.state.riskAlertStakeHolders}
                          renderTags={(value, getTagProps) =>
                            value.map((option, index) => (
                              <Chip
                                variant="outlined"
                                label={option}
                                {...getTagProps({ index })}
                              />
                            ))
                          }
                          PaperComponent={({ children }) => (
                            <div className="paperComponent">
                              <span>{children}</span>
                            </div>
                          )}
                          renderInput={(params) => (
                            <TextField {...params} variant="filled" />
                          )}
                        />
                      </div>
                    </div>
                  )}
                  {this.isHiddenRiskColumn("alertDescription") && (
                    <div className="riskCol col5">
                      <div
                        className="fieldCont textarea-large"
                        title={this.state.riskAlertDescription}
                      >
                        <label>Alert Description</label>
                        <TextArea
                          value={this.state.riskAlertDescription}
                          onChange={(e) => {
                            this.setState({
                              ...this.state,
                              riskAlertDescription: e.value,
                            });
                          }}
                          disabled={isDisabled}
                        />
                      </div>
                    </div>
                  )}
                </div>
              </PanelBarItem>
            </PanelBar>
            <div className="btnGroup">
              {this.state.formEditFlag === true && (
                <button
                  type="button"
                  onClick={this.refreshRisk}
                  className="btnPrimary"
                  disabled={this.getDisableFlagForSubmit()}
                >
                  Refresh
                </button>
              )}
              <button
                type="button"
                onClick={this.saveRisk}
                className="btnPrimary"
                disabled={this.getDisableFlagForSubmit()}
              >
                {this.state.formEditFlag === true ? "Update" : "Add"}
              </button>
              <button
                className="btnPrimary"
                onClick={() => this.init("CANCEL")}
              >
                Cancel
              </button>
            </div>
          </div>
        </Popup>

        <Popup
          show={this.state.progressStatusFlag}
          popupClass={"popup-content popup-wrapper"}
        >
          <div className="deleteModelCont stackHolderSelection">
            <label className="fieldLabel">Progress History</label>
            <div className="commentsHistory">
              <ul className="comments">
                {this.state.formData.riskImpactComments &&
                  this.state.formData.riskImpactComments.map((item) => (
                    <li>
                      <p>{item.riskComment}</p>
                      <small>
                        Date:
                        {moment(new Date(item.createdDate)).format(
                          "DD-MMM-yyyy HH:mm:ss"
                        )}
                      </small>{" "}
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
                      <small>Entered by:{item.userName}</small>
                    </li>
                  ))}
              </ul>
            </div>
            <div className="progressBtn">
              <button
                onClick={this.closeProgressHistoryPopup}
                className="redbtn"
                type="button"
                style={{ "margin-left": "700px", "margin-bottom": "15px" }}
              >
                Cancel
              </button>
            </div>
          </div>
        </Popup>

        {openImpactRatingFlag && (
          <Window
            title={"Rating Table"}
            onClose={this.impactRatingClose}
            className="ratingTable"
            initialLeft={250}
            initialTop={200}
            initialWidth={680}
            initialHeight={530}
            resizable={false}
            minimizeButton={() => null}
            maximizeButton={() => null}
            restoreButton={() => null}
          >
            <div className=" tblCont dataGrids ">
              <div className="rw-tab-content">
                <label>Probability Range</label>
                <Grid
                  data={probabilityRangeMaster}
                  reorderable
                  resizable
                  // total={impactslist.length}
                >
                  {this.state.probabilityvalue}
                </Grid>
              </div>

              <br></br>
              <div className="rw-tab-content">
                <label>Quantitative rating table</label>
                <Grid
                  data={impactslist.slice(skip, take + skip)}
                  reorderable
                  resizable
                  skip={skip}
                  take={take}
                  total={impactslist.length}
                  pageable={true}
                  onPageChange={this.pageChange}
                >
                  <GridColumn
                    field="name"
                    title="Impact"
                    width="150"
                    cell={(props) => (
                      <td
                        title={
                          props.dataItem.name ? props.dataItem.name : "Default"
                        }
                      >
                        {props.dataItem.name ? props.dataItem.name : "Default"}
                      </td>
                    )}
                  />

                  {this.state.probabilityColumns}
                </Grid>
              </div>

              <br></br>
              <div className="rw-tab-content">
                <label>Qualitative rating table</label>
                <Grid
                  data={qualitativeImpactslist.slice(skip, take + skip)}
                  reorderable
                  resizable
                  skip={skip}
                  take={take}
                  total={qualitativeImpactslist.length}
                  pageable={true}
                  onPageChange={this.pageChange}
                >
                  <GridColumn
                    field="name"
                    title="Name"
                    width="150"
                    cell={(props) => (
                      <td>
                        {props.dataItem.name ? props.dataItem.name : "Default"}
                      </td>
                    )}
                  />
                  {this.state.probabilityColumns}
                </Grid>
              </div>
              <br></br>
              {isPrime == true && secureLocalStorage.getItem("isPrime") == true ? (
                <div className="rw-tab-content">
                  <label>Prime Weightings</label>
                  <Grid
                    data={weightageList.slice(skip, take + skip)}
                    reorderable
                    resizable
                    skip={skip}
                    take={take}
                    total={weightageList.length}
                    pageable={true}
                    onPageChange={this.pageChange}
                  >
                    <GridColumn
                      field="impactVariable"
                      title="Impact variable"
                      width="150"
                    />
                    <GridColumn field="ratio" title="Weighting" width="100" />
                  </Grid>
                </div>
              ) : (
                ""
              )}
            </div>
          </Window>
        )}
      </div>
    );
  }
}
